import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _PerformanceCriteria, _TechnicalCriteria, _TranversalCriteria } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";


interface Props {
    IDTransversalSkill: number;
}

export const TechnicalCriteria = ({ IDTransversalSkill }: Props) => {

    const TechnicalCriteria = useDataBean(_TranversalCriteria);

    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDTransversalSkill])

    const getLista = () => {

        TechnicalCriteria.instance.getTransversalCriteriaCatalog(IDTransversalSkill).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                   //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        TechnicalCriteria.setBean({
            IDTransversalSkill: IDTransversalSkill
        });
        setModal({ ...modal, "name": "Agregar Macro Proceso", "view": true });
    }

    const deleteItem = () => {
        TechnicalCriteria.deleteItemVoid(TechnicalCriteria.bean.IDTransversalCriteria).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
       //console.log(TechnicalCriteria.bean);
        TechnicalCriteria.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTransversalCriteria', visible: true },

        { title: 'Descripción', property: 'Description', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo=" Criterios de Desempeño ">
            <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={TechnicalCriteria.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">

                            <div className="col-md-12">
                                <label>Description</label>
                                <textarea name="Description" className="form-control" value={TechnicalCriteria.bean.Description} onChange={TechnicalCriteria.handleChange} />
                            </div>

                        </div>
                    </Modal>


                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}